// extracted by mini-css-extract-plugin
export default {"flagIcon":"FlagIcon_flagIcon__Irz2U","small":"FlagIcon_small__KIYGY","medium":"FlagIcon_medium__Ubj6v","large":"FlagIcon_large__DmNTv"};